import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState, useRef } from "react";

import EditorComponent from "../../../component/editorComponent"; // Import the centralized CKEditor component

const MailerCustom = ()=>{

    const editorRef = useRef(); // Ref to store the CKEditor instance
    const [senderMailData, setSenderMailData] = useState([]);
    const [subject, setSubject] = useState("");
    const [newdata, setNewdata] = useState({
        subject: '', message: '', selectedSenderEmail: ''
    });

    const [selectedCategories, setSelectedCategories] = useState({
        All: false,
        Artist: false,
        Reseller: false,
        Buyer: false,
        Subscriber: false,
    });
    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
     useEffect(() => {
            const fetchDropdowns = async () => {
                fetchData('https://igapi.heuristticminds.com/api/VisitorList/Get-GetMasterEmails', setSenderMailData);
                
            };
            fetchDropdowns();
        },[]);
    

    // Handle checkbox selection
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        if (name === "All") {
            // If "All" is checked, select/unselect all categories
            setSelectedCategories({
                All: checked,
                Artist: checked,
                Reseller: checked,
                Buyer: checked,
                Subscriber: checked
            });
        } else {
            // Handle individual checkbox selection
            setSelectedCategories(prev => ({
                ...prev,
                [name]: checked,
                All: false, // Uncheck "All" if any individual checkbox is toggled
            }));
        }
    };
    
    const handleSubjectChange = (event) => {
        const newSubject = event.target.value;
            setSubject(newSubject);
            setNewdata(prevData => ({
            ...prevData,
            subject: newSubject // Update newdata.subject whenever the Subject changes
    }));
    };

    const handleMessageEditorChange = (messageData) => {
        setNewdata((prevData) => ({
            ...prevData,
            message: messageData, // Only store the message content without the unsubscribe link
          }));
    };

    // Capture the CKEditor instance once it's ready
    const handleEditorReady = (editor) => {
        editorRef.current = editor;
    };

    const handleSubmit = async () =>{
    
        // Create the payload with 1 or 0 for each recipient type
        const payload = {
            artist: selectedCategories.Artist ? 1 : 0,
            reseller: selectedCategories.Reseller ? 1 : 0,
            buyer: selectedCategories.Buyer ? 1 : 0,
            subscriber: selectedCategories.Subscriber ? 1 : 0
        };

        if (
            payload.artist === 0 &&
            payload.reseller === 0 &&
            payload.buyer === 0 &&
            payload.subscriber === 0 
        ) {
            alert("Please select at least one recipient type.");
            return;
        }
        try {
            
            // Fetch email IDs from the database based on selected recipients
            const response = await fetch(`https://igapi.heuristticminds.com/api/MailerList/Get-GetRecipientsEmailList?artist=${payload.artist}&reseller=${payload.reseller}&buyer=${payload.buyer}&subscriber=${payload.subscriber}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                
            });
            
            if (!response.ok) {
                
                alert("error in fatching Email ids");
            }
    
            const emailIds = await response.json(); // Expecting an array of email IDs
    
    
            if (emailIds.length > 0) {
                // Loop through email IDs to send the email (use your email service or API)
                for (const recipient of emailIds) {
                    sendEmail(recipient.email, newdata.subject, newdata.message)
                    /* await fetch('/api/send-mail', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            to: email,
                            subject: newdata.subject,
                            message: newdata.description
                        })
                    }); */
                }
                alert('Emails sent successfully!');
            } else {
                alert('No email IDs found for the selected recipients.');
            }
        } catch (error) {
            console.error('Error sending emails:', error);
            alert('Failed to send emails. Please try again.');
        }

    };

    
    const sendEmail = async (toEmail, subject, message) => {
        try {
            
            // Create the unsubscribe link for the specific recipient
            const unsubscribeLink = `<p>If you no longer wish to receive emails, <a href="https://igapi.heuristticminds.com/api/unsubscribe?email=${encodeURIComponent(toEmail)}">unsubscribe here</a>.</p>`;
    
            // Append the unsubscribe link to the message body
            const personalizedMessage = `${message} ${unsubscribeLink}`;

            const emailResponse = await fetch('http://localhost:3000/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    to: toEmail,
                    subject: subject,
                    html:  personalizedMessage                   
                    
                }),
            });

            if (emailResponse.ok) {
                console.log('Email sent successfully');
            } else {
                const errorDetails = await emailResponse.json();
                console.error('Failed to send email SignUp page:', errorDetails);
                alert("Registered Successfully, but failed to send email.");
            }
        } catch (error) {
            console.error('Error occurred while sending email:', error);
            alert('An error occurred while sending the email.');
        }
    };
const onChangehandle =()=>{

};


return(
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Custom Mailer' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Custom Mailer</div>
                                    <div className="card-body">
                                        
                                        <div className="clearfix"></div>
                                        <div className="p-4 pt-2">
                                        <div className="row">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <label> Select Sender Email <span style={{ color: "#ff0000" }}>*</span></label>
                                                        <select value={newdata.selectedCategory} onChange={onChangehandle} name="selectedCategory" className="form-control form-select">
                                                            <option value="0">-- Select --</option>
                                                                {senderMailData.map((MailData) => (
                                                                <option key={MailData.id} value={MailData.id}>
                                                                        {MailData.masterEmail}</option>
                                                            ))}
                                                        </select>
                                                </div>
                                            </div>
                                            {/* Checkbox List */}
                                            <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <label>Select Recipients <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            name="All"
                                                            checked={selectedCategories.All}
                                                            onChange={handleCheckboxChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label">All</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            name="Artist"
                                                            checked={selectedCategories.Artist}
                                                            onChange={handleCheckboxChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label">Artist</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            name="Reseller"
                                                            checked={selectedCategories.Reseller}
                                                            onChange={handleCheckboxChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label">Reseller</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            name="Buyer"
                                                            checked={selectedCategories.Buyer}
                                                            onChange={handleCheckboxChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label">Buyer</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            name="Subscriber"
                                                            checked={selectedCategories.Subscriber}
                                                            onChange={handleCheckboxChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label">Subscriber</label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Subject Input */}
                                            <div className="row">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <label>Subject <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <input type="text"
                                                        name="subject"
                                                        value={subject}
                                                        className="form-control"
                                                        maxLength={45}
                                                        placeholder="Subject"
                                                        onChange={handleSubjectChange} />
                                                </div>
                                            </div>
                                                <div className="row">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <label>Message Body<span style={{ color: "#ff0000" }}>*</span></label>
                                                    <EditorComponent
                                                            isAdvanced={true} // Set to true for advanced editor with image upload
                                                            data={newdata.message} // Initial data for the editor
                                                            onReady={handleEditorReady} // Capture the editor instance
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData();
                                                                handleMessageEditorChange(data); // Pass only the data here
                                                              }}
                                                            placeholder="Enter Message"

                                                        />
                                                </div>
                                            </div>
                                            
                                               
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 form-group mt-3">
                                                <button type="button" onClick={handleSubmit} className="btn btn-primary w-50">Send Emails</button>
                                               

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <Footer />
                </div>                
            </div>
        </>
    )

};
export default MailerCustom;